import React from 'react';
import {Box, Stack, Typography} from "@mui/material"
import CellJson from "../../api/json/CellJson"
import {AnyColumnJson} from "../../api/json/ColumnJson"
import CellInputWithHelperText from "./CellInputWithHelperText"

interface CellInputGroupProps {
    title?: string
    cells: CellJson[]
    columns: AnyColumnJson[]
    onChange: (newValue: string, reference: string) => void
}

function CellInputGroup({title, cells, columns, onChange}: CellInputGroupProps) {
    return (
        <Box>
            {title && <Typography variant="subtitle1">{title}</Typography>}
            <Stack spacing={2} sx={{mt: 1.5}}>
                {columns.map(column => {
                        const cell = cells.find(it => it.column.reference === column.reference)
                        return (
                            <CellInputWithHelperText
                                key={column.id}
                                column={column}
                                value={cell?.value ?? ""}
                                onChange={(newValue) => onChange(newValue, column.reference)}
                            />
                        )
                    },
                )}
            </Stack>
        </Box>
    );
}

export default CellInputGroup;
